import { Chart, registerables } from "chart.js";
import { buildChartConfig, type DriverActivityData } from "./buildChartConfig";
import { wireDrillDown } from "./wireDrillDown";

Chart.register(...registerables);

type Inputs = {
  canvasElement: HTMLCanvasElement;
  data: DriverActivityData;
  // The drill-down elements only exist for bucketed (bar) views; they are null on
  // the all-time pie, so the wiring is gated on both the data kind and their presence.
  tableBodyElement: HTMLElement | null;
  scopeElement: HTMLElement | null;
  resetElement: HTMLElement | null;
  userPathTemplate: string | undefined;
};

export function initDriverActivityChart({
  canvasElement,
  data,
  tableBodyElement,
  scopeElement,
  resetElement,
  userPathTemplate,
}: Inputs): Chart {
  const chart = new Chart(canvasElement, buildChartConfig(data));

  if (data.kind === "bar" && tableBodyElement && scopeElement && resetElement && userPathTemplate) {
    wireDrillDown({ chart, data, tableBodyElement, scopeElement, resetElement, userPathTemplate });
  }

  return chart;
}
